import styled from '@emotion/styled';

export const CloseButton = styled.div`
    font-family: GreycliffCF, serif;
    font-size: 15px;
    font-style: normal;
    font-weight: 800;
    line-height: 18px;
    letter-spacing: 0.10000000149011612px;
    text-transform: capitalize;
    text-decoration: underline;
    cursor: pointer;
    margin-left: 55px;
`;

export const ToastWrapper = styled.div`
    max-height: 55px;
    width: 100%;
    display: flex;
`;
